import React from "react";
import { useState } from "react";
import "./ZoomComponent.scss";
import { useGesture } from "@use-gesture/react";

var zoomLevel = 13;
var minZoomLevel = 6;
var maxZoomLevel = 20;
var initialZoomLevel = 13;
export default function ZoomComponent({ mainRef }) {
  const [zoomPercentage, updateZoomPercentage] = useState(100);

  const handleZoomOut = (level) => {
    // console.log("Zoom Out Triggered");
    zoomLevel = zoomLevel - level;
    updateBodyFontSize(zoomLevel);
  };

  const handleZoomIn = (level) => {
    // console.log("Zoom In Triggered");
    zoomLevel = zoomLevel + level;
    updateBodyFontSize(zoomLevel);
  };

  const updateBodyFontSize = (size) => {
    toogleZoomOutBtnDisabledStatus(zoomLevel <= minZoomLevel);
    toogleZoomInBtnDisabledStatus(zoomLevel >= maxZoomLevel);
    document.documentElement.style.fontSize = size + "px";
    calculatePercentage();
  };

  const toogleZoomOutBtnDisabledStatus = (status) => {
    document.getElementById("zoom-out-btn").disabled = status;
  };
  
  const toogleZoomInBtnDisabledStatus = (status) => {
    document.getElementById("zoom-in-btn").disabled = status;
  };

  const calculatePercentage = () => {
    // console.log(initialZoomLevel, minZoomLevel, zoomLevel);
    const range = initialZoomLevel - minZoomLevel;
    const correctedStartValue = zoomLevel - minZoomLevel;
    const percentage = Math.ceil((correctedStartValue * 100) / range);
    updateZoomPercentage(percentage);
  };

  // Gesture
  useGesture(
    // {
    //   onPinch: (d) => {
    //     console.log(d.direction);
    //     return d.memo;
    //   },
    // },
    {
      onPinch: ({
        distance: [dist],
        direction: [dir], // to check if zoomin/out (positive means zoom-in, negative means zoom-out)
        memo,
      }) => {
        if (dir > 0) {
          if (zoomLevel <= maxZoomLevel) handleZoomIn(dist);
        } else {
          if (zoomLevel >= minZoomLevel) handleZoomOut(dist);
        }
        return memo;
      },
    },
    {
      target: mainRef,
      pinch: { scaleBounds: { min: 0.1, max: 0.5 }, rubberband: true },
    }
  );

  return (
    <aside className="zoom-slider-wrapper">
      <div className="zoom-slider">
        <button
          tabIndex="-1"
          onClick={handleZoomOut.bind(this, 1)}
          id="zoom-out-btn"
        >
          -
        </button>
        <span className="display-percentage">{zoomPercentage} %</span>
        <button
          tabIndex="-1"
          onClick={handleZoomIn.bind(this, 1)}
          id="zoom-in-btn"
        >
          +
        </button>
      </div>
    </aside>
  );
}
